import { render, staticRenderFns } from "./SendPaymentsButton.vue?vue&type=template&id=0dcea784&"
import script from "./SendPaymentsButton.vue?vue&type=script&lang=js&"
export * from "./SendPaymentsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports